export default {
    // 获取Url参数
    getUrlParams() {
        var map = {};
        var paramsArr = window.location.href.split("#")[0].split("?");
        if(paramsArr.length < 2){
            return map;
        }
        paramsArr = paramsArr[1].split("&");
        for(var i = 0 ; i < paramsArr.length; i ++) {
            var querys = paramsArr[i].split("=")
            map[querys[0]] = querys[1];
        }
        return map;
    }
}



// WEBPACK FOOTER //
// ./src/util/splitUrlUtil.js